<template>
    <div class="c-tr">
        <div class="c-td">
            <fraction-label :fraction="fraction" />
        </div>
        <div class="c-td">
            <span
                class="status is-unavailable"
                v-text="'Zamknięty'"
            />
        </div>
        <div class="c-td">
            <div class="text-center d-inline-block">
                <div v-html="$options.sealNumber(bag.seal_number, shouldHighlightSealPrefix)" />
                {{ operatorName }}
            </div>
        </div>
        <div class="c-td">
            <strong v-text="total" /> ({{ quantity }}&nbsp;szt.)
        </div>
    </div>
</template>

<script>
import sealNumber from '@/helpers/seal-number'
import bagsMixin from '@/components/drs/stores/bags/bags.mixin'

export default {
    sealNumber,

    mixins: [bagsMixin],

    props: {
        bag: {
            type: Object,
            required: true
        }
    },

    methods: {
        goToBagActionModal() {
            const componentPath = this.isOpen ? 'drs/stores/bags/CloseBag' : 'drs/stores/bags/EditBag'
            const args = { bag: this.bag }

            this.$store.dispatch('openModal', { componentPath, args })
        }
    }
}
</script>